import React, { useState } from 'react';
import Modal from 'react-modal';
import { CheckIcon } from '@heroicons/react/24/solid';
import Button from './Button';
import { axiosKK } from '../services/networkRequest';

const customStyles = {
  content: {
    display: 'flex',
  },
};

interface ConfirmationModalProps {
  show: boolean;
  close: () => void;
  success: () => void;
  failure: () => void;
  id: number | string;
  directory: string;
  warningMessage: string;
}

export default function ConfirmationModal({
  show,
  close,
  id,
  directory,
  warningMessage,
  success,
  failure,
}: ConfirmationModalProps): JSX.Element {
  const [busy, setBusy] = useState(false);

  const onConfirm = () => {
    if (busy) return;
    setBusy(true);
    axiosKK
      .put(`${directory}${id}`)
      .then(() => {
        success();
      })
      .catch(() => {
        failure();
      })
      .finally(() => setBusy(false));
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={close}
      style={customStyles}
      contentLabel="Confirmation Modal"
    >
      <section className="confirmation-modal">
        <div className="title">
          <h3>Are you sure?</h3>
        </div>
        <div className="content">
          <p>{warningMessage}</p>
        </div>
        <div className="buttons">
          <Button
            variant="success"
            onClick={onConfirm}
            loading={busy}
            leftIcon={<CheckIcon aria-hidden="true" />}
          >
            Yes
          </Button>
          <Button variant="secondary" onClick={close} disabled={busy}>
            No
          </Button>
        </div>
      </section>
    </Modal>
  );
}
